
export enum MealType {
  Breakfast = '早餐',
  Lunch = '午餐',
  Dinner = '晚餐',
  LateNight = '夜宵'
}

export interface Merchant {
  id: string;
  name: string;
  counts: Record<MealType, number>;
}

export interface SampleRecord {
  id: string;
  merchantId: string;
  dishName: string;
  weight: number;
  samplingTime: string;
  expiryTime: string;
  sampler: string;
  mealType: MealType;
  photoUrl: string;
  chef: string;
}

export type View = 'dashboard' | 'records' | 'sampling';
